import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { Elements, PaymentRequestButtonElement, useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import AppContext from "../../contexts/AppContext";
import mainService from "../../services/authService";
import { toast } from "react-toastify";


//const stripePromise = loadStripe('pk_test_R00q6oRX8Zg5Qz3bDUqUivcK00vfUkcN9F');

export default function InjectGooglePay(props) {

    const contextType = useContext(AppContext);
    const stripePromise = loadStripe(contextType.state.stripeKey);

    return (
        <Elements stripe={stripePromise} stateItems={props.stateItems}>
            <GooglePay states={props.states} handleFormValidation={props.handleFormValidation}/>
        </Elements>
    );
}


const GooglePay = (props) => {
    const stripe = useStripe();
    const elements = useElements();
    const [paymentRequest, setPaymentRequest] = useState(null);
    const [loading, setLoading] = useState(false);
    const [noGPayCardButton, setNoGpayCardButton] = useState(false);
    const [throbEffect, setThrobEffect] = useState(false);

    const handlePayment = () => {
        let fields = props.states.item;
        let formIsValid = true;

        if (!fields.agree) {
            formIsValid = false;
            props.states.errors.agree = "Please agree to our terms and conditions.";
        }
        if (formIsValid == true) {
            setThrobEffect(true);
            paymentRequest.show();
        }
    }

    const closeModal = () => {
        setNoGpayCardButton(false);
        let elem = document.querySelector('.gpay-submit-button-container');
        let parentsUntil = getParentsUntil(elem, '.checkout');
        for (var i = 0; i < parentsUntil.length; i++) {
            console.log(parentsUntil[i]);
            parentsUntil[i].classList.remove("static-position-holder");
        }
        document.querySelector('.checkout.new').classList.remove('no-gpay-card-container');
    }

    const getParentsUntil = (elem, parent, selector) => {

        var parents = [];
        if (parent) {
            var parentType = parent.charAt(0);
        }
        if (selector) {
            var selectorType = selector.charAt(0);
        }

        // Get matches
        for (; elem && elem !== document; elem = elem.parentNode) {

            // Check if parent has been reached
            if (parent) {

                // If parent is a class
                if (parentType === '.') {
                    if (elem.classList.contains(parent.substr(1))) {
                        break;
                    }
                }

                // If parent is an ID
                if (parentType === '#') {
                    if (elem.id === parent.substr(1)) {
                        break;
                    }
                }

                // If parent is a data attribute
                if (parentType === '[') {
                    if (elem.hasAttribute(parent.substr(1, parent.length - 1))) {
                        break;
                    }
                }

                // If parent is a tag
                if (elem.tagName.toLowerCase() === parent) {
                    break;
                }
            }

            if (selector) {
                if (selectorType === '.') {
                    if (elem.classList.contains(selector.substr(1))) {
                        parents.push(elem);
                    }
                }
                if (selectorType === '#') {
                    if (elem.id === selector.substr(1)) {
                        parents.push(elem);
                    }
                }
                if (selectorType === '[') {
                    if (elem.hasAttribute(selector.substr(1, selector.length - 1))) {
                        parents.push(elem);
                    }
                }
                if (elem.tagName.toLowerCase() === selector) {
                    parents.push(elem);
                }
            } else {
                parents.push(elem);
            }
        }

        // Return parents if any exist
        if (parents.length === 0) {
            return null;
        } else {
            return parents;
        }
    };

    useEffect(() => {
        
        if (!stripe || !elements) {
            return;
        }

        const pr = stripe.paymentRequest({
            country: 'US',
            currency: 'usd',
            total: {
                label: 'ProWriter Plus Subscription',
                amount: 9700,
            },
            requestPayerName: false,
            requestPayerEmail: false,
        });

        // Check the availability of the Payment Request API.
        pr.canMakePayment().then(result => {
            let elem = document.querySelector('.gpay-submit-button-container');
            let parentsUntil = getParentsUntil(elem, '.checkout');
            console.log(parentsUntil);

            if (result) {
                for (var i = 0; i < parentsUntil.length; i++) {
                    console.log(parentsUntil[i]);
                    parentsUntil[i].classList.remove("static-position-holder");
                }
                document.querySelector('.checkout.new').classList.remove('no-gpay-card-container');
                setPaymentRequest(pr);
            } else {
                for (var i = 0; i < parentsUntil.length; i++) {
                    console.log(parentsUntil[i]);
                    parentsUntil[i].classList.add("static-position-holder");
                }
                document.querySelector('.checkout.new').classList.add('no-gpay-card-container');
                setNoGpayCardButton(true);
            }
        });

        pr.on('paymentmethod', async (ev) => {
            setLoading(true);
            console.log(ev); 
            const data = await mainService
                .post("/process-payment", {
                    fname: props.states.item.fname,
                    lname: props.states.item.lname,
                    email: props.states.item.email,
                    address: props.states.item.address,
                    country: props.states.item.country,
                    city: props.states.item.city,
                    zip: props.states.item.zip,
                    province: props.states.item.province,
                    payment_method_details: props.states.item.payment_method_details,
                    payment_method_id: ev.paymentMethod.id
                })
                .then(res => {
                    console.log(res);
                    return res.data;
                })
                .catch(error => {
                    setLoading(false);
                    toast.error('Something went wrong.Please try after refreshing the page');
                    return Promise.reject(error);
                });            

            if(data.data.state == true) {
                ev.complete('success');
                let clientSecret = data.data.setUpIntentDetails.client_secret;
                let setUpIntentId = data.data.setUpIntentDetails.id;

                const confirmCardSetupResult  = await stripe.confirmCardSetup(
                    clientSecret,
                    {
                        payment_method: ev.paymentMethod.id
                    }
                   
                ).then((confirmCardSetupResult) => {
                    if (confirmCardSetupResult.error) {
                        setLoading(false);
                        ev.complete('fail');
                        toast.error(confirmCardSetupResult.error.message);
                        //contextType.state.showCodeMessage(confirmCardSetupResult.error.message);
                    } else {
                        console.log(confirmCardSetupResult.setupIntent);
                        ev.complete('success');
                        let states= [];
                        states = props.states;
                        states.item.card = ev.paymentMethod.card;

                        return  mainService
                            .post("/set-customer-subscription", {
                                confirmCardSetupResult: confirmCardSetupResult,
                                item: states.item,
                                paymentMethod: ev.paymentMethod
                            })
                            .then(res => {
                                console.log(res); 
                                // contextType.state.showCodeMessage(res.data.message, 'success');
                                localStorage.setItem('user_steps', 'account');
                                localStorage.setItem("user", JSON.stringify(res.data.data));

                                if (res.data.meta.token) {
                                    setTimeout(() => {
                                        window.location = '/account';
                                    }, 3000);
                                }
                                //return res.data;
                            })
                            .catch(error => {
                                setLoading(false);
                                console.log(error);
                                toast.error('Something went wrong.Please try after refreshing the page');
                                return Promise.reject(error);

                                //contextType.state.showCodeMessage('Something went wrong. Please try after refreshing the page', 'danger');
                            });
                    }
                });
            } 
        });
    }, [stripe, elements, props]);

  

    return (
        <div className="col px-0 gpay-submit-button-container">
            {/* {paymentRequest && <PaymentRequestButtonElement options={{ paymentRequest }} />} */}
            {paymentRequest && <button type="submit" onClick={handlePayment} disabled={loading} className={"btn btn-primary checkout-process-btn border-0 mx-auto d-block" + (throbEffect ? "throb" : '')}>{loading ? `Processing...` : `Confirm Membership`} <i className={loading ? `ml-2 fas fa-spinner fa-spin` : `ml-2 fas fa-lock`}></i></button>}
            
            {noGPayCardButton &&
                <div className="model-container model-center model-backdrop-show">
                    <button onClick={closeModal} type="button" className="modal-close" data-dismiss="modal" aria-hidden="true"><img src="/images/close.svg" alt="close" /></button>
                    <div
                        aria-labelledby="model-title"
                        aria-describedby="model-content"
                        className="model-popup model-modal model-show"
                        role="dialog"
                        aria-live="assertive"
                        aria-modal="true"
                    >
                        <div className="model-header mt-0 mb-3">
                            <img src="/images/creditCardModel.png" alt=""></img>
                        </div>
                        <h2 className="model-title text-center mb-3" id="model-title">
                        Either your browser does not support the payment method, or you do not have a saved payment method.
                        </h2>
                        <div className="model-actions">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={closeModal}
                            >
                                Close
                            </button>
                        </div>
                    
                    </div>
                </div>
            }
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/payment/GooglePaySubscription.js